import { postRequest } from '@/utils/http'

interface testParams {
  name: string,
  password: string
}
export async function test (params:testParams) {
  return postRequest('https://devpplatform-api.ecoach.evideo.tech/backend/auth/login', params)
}
